export const formatInputValue = (startDate, endDate) =>
  [startDate, endDate].map((d) => d?.toFormat('Qq yyyy') || '...').join(' - ')
